import { CountrySelector } from './country-selector'
import { useCountryStore } from '@/shared/stores/country'
import { useSetPreferredCountry } from '@/features/profile/hooks/useSetPreferredCountry'
import { getCountryFromCode } from '@/shared/constants/countries'
import { cn } from '@/shared/lib/utils'

export interface CountryFlagButtonProps {
  className?: string
}

export function CountryFlagButton({ className }: CountryFlagButtonProps) {
  const country = useCountryStore((state) => state.country)
  const { mutate } = useSetPreferredCountry()
  const selected = getCountryFromCode(country)

  return (
    <CountrySelector
      value={country}
      onChange={mutate}
      trigger={
        <button
          type="button"
          aria-label="Change country"
          className={cn(
            'flex h-8 w-8 items-center justify-center rounded-full bg-white/10 text-lg transition-colors hover:bg-white/20',
            className
          )}
        >
          {selected.emoji}
        </button>
      }
    />
  )
}
